// extracted by mini-css-extract-plugin
export default {"legend":"cka-z","legendSpacing":"dka-z"};